module.exports = __webpack_public_path__ + "static/media/icn_clock.bad7bcd0.svg";